import React from 'react';
import { FadeIn } from './FadeIn';
import { Timer } from 'lucide-react';
export function UrgencySection() {
  return <section className="py-12 md:py-20 px-4 max-w-4xl mx-auto text-center" data-id="element-151">
      <FadeIn data-id="element-152">
        <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-brand-gold/20 text-brand-gold-dark mb-8" data-id="element-153">
          <Timer size={40} data-id="element-154" />
        </div>
        <div className="space-y-6 md:space-y-8 text-lg md:text-2xl text-brand-dark font-medium leading-relaxed" data-id="element-155">
          <p data-id="element-156">
            Esto no es un curso. No tenés que estudiar nada ni esperar a
            terminar un módulo para aplicarlo.
          </p>
          <p className="font-black text-brand-green text-2xl md:text-4xl" data-id="element-157">
            Comprás hoy, descargás hoy, y mañana entrás a la primera consulta
            con todo listo.
          </p>
          <p className="text-brand-muted" data-id="element-158">
            Cada hora que seguís improvisando es una hora que le estás regalando
            a alguien que no te la paga.
          </p>
        </div>
      </FadeIn>
    </section>;
}